// extracted by mini-css-extract-plugin
module.exports = {"payModal":"_2UAjT","money":"_ow6W","payBtn":"_3PAVv","cover":"_17Fh6","paypal-button-container":"_1I53F"};